import { adminAcceptBooking, adminRejectBooking } from '../../api'
import { bookingNotificationDecisionChanged } from '../../reducers/ui'

export const getBookingDecision = (store, bookingId) => store.getState().ui.bookingDecisions?.[bookingId]?.decision

export const decidePendingBooking = async (store, booking, accept) => {
    const decision = getBookingDecision(store, booking.id)
    if (decision && decision !== 'failed') return
    if (!store.getState().site_admin?.pending_bookings?.some(pending => pending.id === booking.id)) return

    // Redux dispatch is synchronous, so a second click in any view sees the
    // guard immediately. UI state also survives unloading the selected club.
    store.dispatch(bookingNotificationDecisionChanged(booking, accept ? 'accepting' : 'rejecting'))
    try {
        await (accept ? adminAcceptBooking : adminRejectBooking)(booking.id)
        store.dispatch(bookingNotificationDecisionChanged(booking, accept ? 'accepted' : 'rejected'))
    } catch {
        store.dispatch(bookingNotificationDecisionChanged(booking, 'failed'))
    }
}
